import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-servis-odeme-yap',
  templateUrl: 'servis-odeme-yap.html',
})
export class ServisOdemeYapPage {

  vWKayit: any = {};
  serviskaydi: any = { ID: -1 };
  YapilanServis: any = { ID: -1, YapilanIslem: "", Maliyet: "", Aciklama: "", IslemYapan: "", ServiceID: "" };
  HareketListesi = [];
  hareketid = "";
  kasaListesi = [];
  islemyapan = this.ortak.storagePersonelGetir.Name;
  Tahsilat: any = { ID: -1, CariKartID: "", KsCardRef: 1, Tutar: "", SlsMan: "", Text: "Servis işleminden borçlandırmayı kapatma", RefID: 1 }
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public viewCtrl: ViewController,
    public ortak: Ortak,
    public navParams: NavParams) {
    if (navParams.get("vWKayit") != null) {
      this.vWKayit = navParams.get("vWKayit");
      var data = new FormData();
      data.append("Servis_id", this.vWKayit.ID);
      this.bllOrtak.islem(data, "ServisOdemeGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.serviskaydi = Sonuc.SonucObject;

        this.YapilanServis.ServiceID = this.serviskaydi.ID;
        this.Tahsilat.Tutar=this.serviskaydi.ToplamTutar;
      });
    }
    this.hareketgetir();
   
  }

  ionViewDidLoad() {
    this.kasaGetir();
  }
  hareketgetir() {
    var formData = new FormData();
    this.hareketid = this.vWKayit.ID;
    formData.append("Servis_id", this.hareketid);
    this.bllOrtak.islem(formData, "ServisHareketGetirByID", "", false).then(a => {
      var sonuc = <any>a;
      this.HareketListesi = sonuc.SonucObject;
    })
  }
  kasaGetir() {
    var formData = new FormData();
    this.bllOrtak.islem(formData, "OdemeKasaGetir", "", false).then(a => {
      var sonuc = <any>a;
      this.kasaListesi = sonuc.SonucObject;

    })
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  kaydet() {
    if (this.serviskaydi.ToplamTutar < this.Tahsilat.Tutar) {
      this.ortak.showBasicAlert("Uyarı", "Tahsil edilen tutar toplam tutardan büyük olamaz");
    }
    else if (this.Tahsilat.Tutar < 0) {
      this.ortak.showBasicAlert("Uyarı", "Negatif bir tutar giremezsiniz");
    }
    else {
      var formData = new FormData();
      this.Tahsilat.RefID = this.serviskaydi.ID;
      this.Tahsilat.CariKartID = this.serviskaydi.CariID;
      this.Tahsilat.SlsMan = this.islemyapan;
      formData.append("tahsilat_json", JSON.stringify(this.Tahsilat));
      this.bllOrtak.islem(formData, "OdemeYap", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.viewCtrl.dismiss();
      })

    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/servis-odeme-yap/servis-odeme-yap.ts